import { dictList ,getCanteenDicts} from '../api/dict'

export  function dicts(arr, obj) {

    arr.forEach(async item => {
        try {
            const res=await dictList({ pageNum: 1, pageSize: 500, dictType: item})
            console.log(res);
            obj[item] = res.rows
        } catch (error) {
            
        }
    });
    console.log(obj,'=======?');
    return obj
}

export async function dict(arr, obj={}) {
    let data=obj||{}
   await arr.forEach(async (item,index) => {
            const res=await getCanteenDicts(item)
            data[item] = res.data
      })
 return data
}
